import React from 'react';
import DetailBankComponent from './DetailBankComponent';
import { ISettingData } from 'constants/settingBank';
import { getStringNull } from 'helper';

const DetailBank = ({ detailBank, setIsEdit }: { detailBank: ISettingData; setIsEdit: (isEdit: boolean) => void }) => {
  return (
    <DetailBankComponent
      dataDetail={{
        ...detailBank,
        bank_branches_name: detailBank.bank_branches_name
          ? `${detailBank.bank_branches_name} (${detailBank.bank_branches_code})`
          : '',
        bank_name: detailBank.bank_name ? `${detailBank.bank_name} (${detailBank.bank_code})` : '',
        deposit: getStringNull(detailBank.deposit_percentage) || getStringNull(detailBank.deposit_yen) || null,
        advance: getStringNull(detailBank.advance_percentage) || getStringNull(detailBank.advance_yen) || null,
      }}
      isLoading={false}
      setEdit={() => setIsEdit(true)}
      setIsConfirm={() => {}}
      onSubmit={() => {}}
    />
  );
};

export default DetailBank;
